import React from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import { HubButton } from "../../components";
import { useShippingContext } from "../../hooks";

import OutsideFilters from "./OutsideFilters.jsx";

const buttonProps = {
  size: "xsmall",
  iconProps: { size: 10 },
};

const OutsideBar = ({}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { count, getIds = () => {}, onClear = () => {} } = useShippingContext();

  const onFilter = () => {
    const ids = getIds();
    setSearchParams((prev) => {
      if (prev?.has("routeIds")) {
        prev.delete("routeIds");
        return prev;
      }
      const routeIds = ids.join("-");
      prev.append("routeIds", routeIds);
      return prev;
    });
  };
  const hasFilter = searchParams.has("routeIds");
  const buttonFilterProps = hasFilter
    ? {
        label: `Clear ${count} Work Orders Filter`,
        icon: "X",
        variant: "contained",
        color: "info",
      }
    : {
        label: `Filter ${count} Work Orders Items`,
        icon: "Menu",
        variant: "outlined",
        color: "neutral",
      };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap="15px"
    >
      <OutsideFilters />
      <Stack direction={{ lg: "row", md: "row" }} gap="5px" alignItems="center">
        {!!count && (
          <>
            <HubButton
              label={`Clear ${count} Selected`}
              icon="X"
              variant="contained"
              color="grey"
              onClick={onClear}
              {...buttonProps}
            />
            <HubButton
              onClick={onFilter}
              {...buttonFilterProps}
              {...buttonProps}
            />
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default OutsideBar;
